import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from '@buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

const ContributorDashboardNavigation: React.FC<{ isBuyside: boolean }> = ({ isBuyside }) => {
  return (
    <div className={styles.navBar}>
      <h4>Contributor Dashboard</h4>
      <section className={styles.navMenu}>
        {[
          { path: '/ideas', label: 'Ideas' },
          isBuyside ? { path: '/white_papers', label: 'Macro/Thematic' } : null,
          isBuyside ? { path: '/posts', label: 'Insights' } : null,
          isBuyside ? { path: '/fund_profile', label: 'Fund Profile' } : null,
          { path: '/intro_requests', label: 'Intro Requests' }
        ].map(item => {
          if (!item) return null;

          const { path, label } = item;
          return (
            <NavLink
              className={({ isActive }) => (isActive ? styles.selected : null)}
              key={path}
              to={path}
            >
              {label}
            </NavLink>
          );
        })}
      </section>
    </div>
  );
};

export default ContributorDashboardNavigation;
